import { InputTextarea } from "primereact/inputtextarea"
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface IInput {
    label?: string,
    name: string,
    control: any,
    error?: string,
    maxLength?: number,
    required?: boolean,
    disabled?: boolean,
    placeholder?: string,
    column?: number,
    rows?: number,
    onBlur?: () => void
}

export const JVTextArea = (props: IInput) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}
            <Controller name={props.name} control={props.control} render={({ field, fieldState }) => (
                <InputTextarea {...field} maxLength={props.maxLength} onBlur={props.onBlur}
                    disabled={props.disabled}
                    rows={props.rows}
                    placeholder={props.placeholder}
                    className={classNames({ 'p-invalid': fieldState.invalid })} />
            )} />
            <small className="p-error" >{props.error}</small>
        </div>
    );
}